<template>
  <div class="w-full">
    <div class="loader"></div>
  </div>
</template>

<style scoped>
.loader {
  margin: auto;
  border: 10px solid #c4e3ed;
  border-radius: 50%;
  border-top: 10px solid #015d79;
  width: 100px;
  height: 100px;
  animation: spinner 4s linear infinite;
  background: transparent;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
